/* eslint-disable */
export default {
  unknown: 'Inconnu',
  anonymous: 'Anonyme',
  activeCall: 'Appel en cours',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
